module.exports = __webpack_public_path__ + "static/img/curegarden.16a0c317.jpg";